<template>
  <div class="content">
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style scoped>
.content {
  font-size: 1.25vw;
}
</style>
